import { useTranslation } from '@crehana/i18n';
import locales, { ATS_CAREER_SITE_ADMIN_SHARED, type TKeys } from '.';

export const useAddResourceBundle = () => {
  const { addResourceBundle } = useTranslation<TKeys>(
    ATS_CAREER_SITE_ADMIN_SHARED,
  );
  addResourceBundle(locales);
};
